import React from 'react';
import './Partenaires.css';

const Partenaires = () => {
  const partnershipOptions = [
    {
      title: 'Partenariat Média',
      description: 'Soyez présent lors de nos enregistrements et bénéficiez d\'une visibilité exceptionnelle auprès de notre audience engagée.',
      benefits: [
        'Logo affiché pendant les épisodes',
        'Mentions dans les descriptions',
        'Contenu sponsorisé personnalisé',
        'Accès aux statistiques d\'audience'
      ],
      icon: '📺'
    },
    {
      title: 'Partenariat Produit',
      description: 'Mettez en avant vos produits ou services dans nos épisodes et touchez une communauté passionnée.',
      benefits: [
        'Test et présentation de produits',
        'Codes promo exclusifs',
        'Avis authentiques de l\'équipe',
        'Visibilité sur tous nos canaux'
      ],
      icon: '🎁'
    },
    {
      title: 'Partenariat Événement',
      description: 'Collaborez avec nous pour créer des événements mémorables et renforcer votre présence locale.',
      benefits: [
        'Organisation d\'événements communs',
        'Promotion sur nos réseaux sociaux',
        'Interviews et couverture média',
        'Réseautage avec notre communauté'
      ],
      icon: '🎪'
    }
  ];

  return (
    <section className="partenaires" id="partenaires">
      <div className="container">
        <h2 className="partenaires-title">DEVENIR PARTENAIRE</h2>
        <div className="section-divider"></div>
        <p className="partenaires-subtitle">
          Rejoignez-nous et découvrez différentes façons de collaborer avec Le Temps d'une Mousse
        </p>

        <div className="partenaires-grid">
          {partnershipOptions.map((option, index) => (
            <div key={index} className="partenaires-card">
              <div className="partenaires-icon">{option.icon}</div>
              <h3 className="partenaires-card-title">{option.title}</h3>
              <p className="partenaires-card-description">{option.description}</p>
              <ul className="partenaires-benefits">
                {option.benefits.map((benefit, idx) => (
                  <li key={idx} className="partenaires-benefit">
                    <span className="benefit-check">✓</span>
                    {benefit}
                  </li>
                ))}
              </ul>
              <button className="partenaires-button">En savoir plus</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partenaires;

